import React from "react";
import { motion } from "framer-motion";
import { Trophy, Award, Medal, Star } from "lucide-react";
import { featuredAwards } from "../../../data/awards";

// data/awards.js stays plain data; each consumer maps the key to its own icon size
const ICONS = {
  trophy: <Trophy size={40} />,
  medal: <Medal size={40} />,
  star: <Star size={40} />,
  award: <Award size={40} />,
};

const AwardCard = ({ award, index }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: index * 0.2 }}
    className="award-badge-card"
  >
    <div className="award-icon">{ICONS[award.icon]}</div>
    <div className="award-content">
      <span style={{ color: "#75DAB4", fontSize: "14px", fontWeight: 600 }}>
        {award.year}
      </span>
      <h4 className="white-text" style={{ margin: "10px 0" }}>
        {award.title}
      </h4>
      <p className="white-text" style={{ opacity: 0.7, fontSize: "14px" }}>
        {award.description}
      </p>
    </div>
    <div
      className="award-stars mt-3"
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "5px",
        color: "#75DAB4",
      }}
    >
      <Star size={16} fill="#75DAB4" />
      <Award size={16} />
      <Star size={16} fill="#75DAB4" />
    </div>
  </motion.div>
);

const AchievementsAwards = () => {

  return (
    <section className="achievements dl-dark-section sec-pad">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div
              className="sec-title white text-center wow animate fadeInUp"
              data-wow-delay="200ms"
            >
              <span>Recognition</span>
              <h2 className="white-text">
                Our Achievements & Industry Recognition
              </h2>
              <p className="white-text">
                Our work has been recognised by global and local institutions
                backing high-growth technology companies.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          {featuredAwards.map((award, index) => (
            <div key={award.id} className="col-lg-4 col-md-6 mb-4">
              <AwardCard award={award} index={index} />
            </div>
          ))}
        </div>

        <div className="cta-button-container">
          <div className="cmn-btn">
            <a
              href="https://calendly.com/arjun-zcax/dlplatforms"
              target="_blank"
              rel="noopener noreferrer"
            >
              Talk to the Team
            </a>
            <div className="line-1"></div>
            <div className="line-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsAwards;
